module.exports = __webpack_public_path__ + "static/img/kwh_item_image6.3d7bd46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/kwh_item_image6.png
// module id = dSv0
// module chunks = 1